import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { SharedOrganizationFeatureModule } from '@markant-platform/shared/organization/feature';
import { MarkantElementsModule } from '@markant/elements-angular';
import { ModalBridgeComponent } from '@markant-platform/shared/ui-modal';
import { BackofficeFeatureOrganizationBookingsRoutingModule } from './backoffice-feature-organization-bookings-routing.module';

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    SharedOrganizationFeatureModule,
    MarkantElementsModule,
    ModalBridgeComponent,
    BackofficeFeatureOrganizationBookingsRoutingModule,
  ],
  providers: [DatePipe],
})
export class BackofficeFeatureOrganizationBookingsModule {}
